import {
  Avatar,
  Badge,
  createStyles,
  Theme,
  withStyles,
} from '@material-ui/core';
import PersonIcon from '@material-ui/icons/Person';

const UserAvatar = ({
  imageUrl,
  isOnline,
}: {
  imageUrl: string;
  isOnline: boolean | undefined;
}) => (
  <StyledBadge
    variant="dot"
    overlap="circular"
    anchorOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    {...(!isOnline && { color: 'error' })}
  >
    <Avatar src={imageUrl} style={{ width: 32, height: 32 }}>
      <PersonIcon style={{ fontSize: '1.5rem ' }} />
    </Avatar>
  </StyledBadge>
);

const StyledBadge = withStyles((theme: Theme) =>
  createStyles({
    badge: {
      boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
      '&:not(.MuiBadge-colorError)': {
        color: theme.b2chatgreen[600],
        backgroundColor: theme.b2chatgreen[600],
      },
      '&.MuiBadge-colorError': {
        color: theme.b2chatred[500],
        backgroundColor: theme.b2chatred[500],
      },
    },
  })
)(Badge);

export default UserAvatar;
